/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { connect } from 'react-redux'
import { Row,Col,Table } from "react-bootstrap"
import Dialog from 'react-bootstrap-dialog'
import { PropTypes } from "prop-types"
import { red, warning, blue } from '../../../../utils/constants'

class SearchResults extends Component {

	constructor(props)
	{
        super(props);
        this.handleOptOutAdvancer = this.handleOptOutAdvancer.bind(this);
        this.handleViewEventDetails = this.handleViewEventDetails.bind(this);
    }
    
    handleOptOutAdvancer(Id) 
	{
		const customBody = (
			<p>
				<i className="fa fa-exclamation-triangle text-danger" style={{ color:'red' }}/>
				&nbsp;&nbsp;
				<span>Are you sure you want to opt out this advancer? </span>
			</p>
		)

		Dialog.setOptions({
			defaultOkLabel: 'Opt Out',
			defaultCancelLabel: 'Cancel',
			primaryClassName: 'btn-danger'
		})
		Dialog.Action(
			'Opt Out Advancer',
			() => this.props.optOutAdvancer(Id),
			'btn-danger'
		)
		this.dialog.show({
			body: customBody,
			title:'Opt Out Advancer',
			actions: [
                Dialog.CancelAction(),
                Dialog.OKAction(() => this.props.optOutAdvancer(Id))
			],
            bsSize: 'small' 
        })
    }

  handleViewEventDetails(eventId) {
	this.props.onViewEventDetails(eventId);
  }

	render() {
		const {
			searchResults
        } = this.props;
		
        const recordsFound = (searchResults.length > 0);
	
		if (!recordsFound) {
			return (<span style={{ color:warning }}>
				<i className='fa fa-info-circle' />&nbsp;&nbsp;No athletes found
			</span>)
		}
		
		return (		
			searchResults.length > 0 && 
			(
				<Row>
                    <Dialog  ref={(el) => { this.dialog = el }}  />
					<Col xs={12}>
                    <Table striped>
                        <thead>
                            <tr>
                            <th />
                            <th>Advancer Name</th>
                            <th>Membership ID</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Event Name</th>
                            <th>Division</th>
                            <th>Status</th>
                            <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                            searchResults.map((item, key) => (          
                              <tr key={key}>
                                <td>{(searchResults.length) - (key)}</td>
                                <td>{item.firstName + ' ' + item.lastName}</td>
                                <td>{item.membershipId}</td>
                                <td>{item.city}</td>
                                <td>{item.state}</td>
                                <td>
                                  <button className="btn btn-default" style={{ color: blue }} onClick={() => this.handleViewEventDetails(item.eventId)}>
                                    <i aria-hidden="true" />&nbsp;{item.event}
                                  </button>
                                </td>
                                <td>{item.division}</td>
                                <td>{item.status}</td>
                                <td>
                                   <button id={item.id} type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() => this.handleOptOutAdvancer(item.id)} disabled={!item.isActive}>
                                      <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Opt Out
                                   </button>
                                </td>            
                                </tr>
                            ))
                            }
                        </tbody>
                        </Table>
					</Col>
				</Row>
			)
		)
	}
}
SearchResults.propTypes = {
    searchResults: PropTypes.array,
  optOutAdvancer: PropTypes.func,
  onViewEventDetails: PropTypes.func
}

const mapStateToProps = ({ oidc, user }) => {
  return {
    oidc: { ...oidc },
    user: { ...user },
  }
}
export default (connect(mapStateToProps, null)(SearchResults));
  



// WEBPACK FOOTER //
// ./src/containers/postevent/components/manageAdvancers/searchresults.js